<!-- ModuleDemoVideo.vue -->

<template>
  <div
    class="fixed bottom-0 left-0 w-full h-2/6 flex justify-start items-end z-50"
    v-if="showDemoVideo"
  >
    <div
      class="bg-black bg-opacity-70 absolute top-0 left-0 w-full h-full"
    ></div>

    <img
      class="absolute top-0 right-0 mt-2 mr-2 bg-primary opacity-80 text-white px-2 py-1 h-6 object-contain cursor-pointer hover:shadow-lg rounded-md"
      src="@/assets/icons/cross-white.png"
      @click="closeDemoVideo"
    />
    <div class="rounded-lg overflow-hidden relative w-full md:w-2/6 h-full">
      <div class="relative w-full h-full">
        <iframe
          class="w-full h-full"
          :src="videoUrl"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showDemoVideo: Boolean,
    videoUrl: String,
  },
  methods: {
    closeDemoVideo() {
      this.$emit("close");
    },
  },
};
</script>
